var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Stack } from "native-base";
const Bar = (_a) => {
    var { data, width = "full", height = 6, summary = 0 } = _a, rest = __rest(_a, ["data", "width", "height", "summary"]);
    const [sum, setSum] = useState(summary);
    useEffect(() => {
        if (!summary) {
            const _sum = data.reduce((prev, { value }) => prev + value, 0);
            setSum(_sum);
        }
    }, [data, summary]);
    return (_jsx(Stack, Object.assign({ width: width, direction: "row", borderRadius: "sm", overflow: "hidden" }, rest, { children: data.map((item, index) => (_jsx(Box, { height: height, width: `${(item.value / sum) * 100}%`, bgColor: item.color }, `bar-data-item-${index}`))) })));
};
export default Bar;
